import PropTypes from 'prop-types';
// import Styles from './Timeline.module.scss';
import { timeline } from 'data/timeline';
import { useState, useEffect } from 'react';

export default function Timeline({ sort }) {
    const [data, setData] = useState(timeline);

    useEffect(() => {
        setData(
            data.sort((a, b) => (sort === 'desc' ? (a.id > b.id ? 1 : -1) : a.id < b.id ? 1 : -1)),
        );
    }, [data, sort]);

    return (
        <>
            {data.map((item, index) => (
                <div
                    key={item.id}
                    className={`tile is-ancestor is-vertical ${
                        index % 2 === 0 ? 'is-align-items-flex-start' : 'is-align-items-flex-end'
                    }`}
                >
                    <div className="tile is-parent is-6 is-relative">
                        <span
                            className={`timeline-point ${
                                index % 2 === 0 ? 'right' : 'left'
                            } is-hidden-mobile`}
                        ></span>

                        <article className="tile is-child box">
                            <p className="title has-text-grey-dark is-size-5">
                                <span className="circle"></span>
                                {item.title}
                            </p>
                            <p className="subtitle is-italic has-text-grey is-size-7 pt-2">
                                {item.date}
                            </p>
                            <div
                                className="content is-size-6"
                                dangerouslySetInnerHTML={{ __html: item.content }}
                            />
                        </article>
                    </div>
                </div>
            ))}
        </>
    );
}

Timeline.propTypes = {
    sort: PropTypes.string,
};

Timeline.defaultProps = {
    sort: 'asc',
};
